import openChat from 'utils/open-chat'

/**
 * Global floating chat button.
 * - Opens the Olark widget on click.
 * - Hides once the footer reaches the button and comes back when the footer
 *   scrolls away again, so it never overlaps the footer content.
 * - While the button overlaps a section flagged with `data-dark-mode="true"`
 *   it cross-fades from the default artwork to the alternative one, reversing
 *   the button against the dark background.
 *
 * The inversion only runs when an alternative artwork was set in Theme
 * Settings, otherwise inverting would fade the button out entirely.
 */
const INVERSE_CLASS = 'redesign-chat-button--inverse'
const HIDDEN_CLASS = 'redesign-chat-button--hidden'

export default (el) => {
  el.addEventListener('click', () => {
    openChat()
  })

  const footer = document.querySelector('.redesign-footer')
  const hasAltArtwork = Boolean(el.querySelector('.redesign-chat-button__artwork--alt'))

  if (!footer && !hasAltArtwork) return

  const isOverDarkSection = (probe) => {
    for (const section of document.querySelectorAll('[data-dark-mode="true"]')) {
      const rect = section.getBoundingClientRect()

      if (rect.top <= probe && rect.bottom >= probe) {
        return true
      }
    }

    return false
  }

  let ticking = false

  const apply = () => {
    // The button is fixed, so its own rect is stable while the page moves past it.
    // It stays measurable while hidden because hiding never sets display: none.
    const rect = el.getBoundingClientRect()
    const probe = rect.top + rect.height / 2

    if (footer) {
      el.classList.toggle(HIDDEN_CLASS, footer.getBoundingClientRect().top <= probe)
    }

    if (hasAltArtwork) {
      el.classList.toggle(INVERSE_CLASS, isOverDarkSection(probe))
    }

    ticking = false
  }

  const onScroll = () => {
    if (ticking) return
    ticking = true
    window.requestAnimationFrame(apply)
  }

  apply()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll, { passive: true })
}
